import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

export default function RefundPolicy() {
  return (
    <div>
      <SEO
        title="Refund Policy"
        path="/refund"
        description="InstaVivah refund and cancellation policy for Premium memberships. Learn our 7-day satisfaction promise and how to request a refund."
        keywords="refund policy, matrimonial refund, biodata premium refund, InstaVivah cancellation"
      />
      <Navbar />

      <header className="sb-page-hero text-center">
        <div className="container">
          <div className="sb-kicker mb-2">Fair &amp; Transparent</div>
          <h1>Refund Policy</h1>
          <p>Last updated: {new Date().toLocaleDateString("en-IN", { month: "long", year: "numeric" })}</p>
        </div>
      </header>

      <main className="container py-5">
        <article className="sb-prose">
          <p>
            Our Free plan is, and will always remain, free. Biodata creation
            and PDF/DOCX download require no payment. This Refund Policy
            applies to <strong>InstaVivah Premium</strong> paid memberships.
          </p>

          <h2>1. 7-day satisfaction promise</h2>
          <p>
            If you upgrade to Premium and are not satisfied within the first
            <strong> 7 calendar days</strong> of activation, you may request a
            full refund — no questions asked — provided you have not sent
            more than 3 interest requests using Premium benefits.
          </p>

          <h2>2. Eligibility</h2>
          <ul>
            <li>
              Request received within 7 days of the payment being verified.
            </li>
            <li>Account is in good standing (no policy violations).</li>
            <li>
              Payment was made through our approved UPI channel with a valid
              transaction reference.
            </li>
          </ul>

          <h2>3. Non-refundable situations</h2>
          <ul>
            <li>
              Refund requests raised after the 7-day window from activation.
            </li>
            <li>
              Accounts suspended or terminated for violating our Terms of
              Service, community guidelines, or applicable law.
            </li>
            <li>
              Requests where you have already contacted 4 or more members
              using Premium features.
            </li>
          </ul>

          <h2>4. How to request a refund</h2>
          <ol>
            <li>
              Email{" "}
              <a href="mailto:refunds@instavivah.com">
                refunds@instavivah.com
              </a>{" "}
              from the same address registered with your account.
            </li>
            <li>
              Include your UPI transaction reference and, optionally, a short
              note on what didn’t work for you — we love the feedback.
            </li>
            <li>
              We’ll acknowledge within 24 hours and process eligible refunds
              within 5–7 business days to your original payment method.
            </li>
          </ol>

          <h2>5. Cancellation vs refund</h2>
          <p>
            You may cancel your Premium plan at any time from your{" "}
            <Link to="/premium">Premium page</Link>. Cancellation stops
            auto-renewal but does not automatically issue a refund for the
            current term. Refunds are governed by clauses 1–4 above.
          </p>

          <h2>6. Chargebacks</h2>
          <p>
            If you disagree with our decision, please write to us first —
            we’re a small human team and almost every dispute can be resolved
            over email. Filing a bank chargeback without contacting us first
            may result in your account being suspended.
          </p>

          <h2>7. Questions</h2>
          <p>
            For anything related to refunds, cancellations or payment
            verification, please write to{" "}
            <a href="mailto:refunds@instavivah.com">
              refunds@instavivah.com
            </a>{" "}
            or use our <Link to="/contact">Contact page</Link>.
          </p>
        </article>
      </main>

      <Footer />
    </div>
  );
}
